import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'fluxible-router';
import styles from './styles.module.styl';

const NavLinks = ({
  currentSection,
  sections,
  onClick
}) => (
  <ul className={styles.navbarLinks}>
    {sections.map(section => (
      <li key={section.id} className={currentSection === section.id ? 'active' : ''} onClick={onClick}>
        <NavLink href={section.url}>
          {section.title}
        </NavLink>
      </li>
    ))}
  </ul>
);

NavLinks.propTypes = {
  currentSection: PropTypes.string,
  sections: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired
};

export default NavLinks;
